import { useFlags, useLDClient } from 'launchdarkly-react-client-sdk'
import { useEffect, useState } from 'react'

import { FEATURE_FLAGS } from '@infura/packages.common/constants'

export interface IFeatureToggleProps {
  flag: FEATURE_FLAGS
  children?: React.ReactElement
  fallback?: React.ReactElement
  waitUntilFlagReady?: boolean
}

const FeatureToggle: React.FC<IFeatureToggleProps> = ({ children, fallback, flag, waitUntilFlagReady }) => {
  const ldClient = useLDClient()
  const flags = useFlags()

  const [loading, setLoading] = useState(true)

  useEffect(() => {
    if (ldClient) {
      ;(async () => {
        await ldClient.waitUntilReady()
        setLoading(false)
      })()
    }
  }, [ldClient])

  if (waitUntilFlagReady && loading) return null

  return flags[flag] ? children || null : fallback || null
}

export default FeatureToggle
